export const device = {
//   xm: 'only screen and (max-width: 575px)',
//   sm: 'only screen and (min-width: 576px)',
//   md: 'only screen and (min-width: 768px)',
//   lg: 'only screen and (min-width: 992px)',
//   xl: 'only screen and (min-width: 1200px)',
  mobile: 'only screen and (max-width: 575px)',
  tablet: 'only screen and (min-width: 576px)',
  desktop: 'only screen and (min-width: 992px)',
};